export default __webpack_public_path__ + "static/media/capn2.9042ae7f.png";